import { useState, useEffect } from 'react';
import { checkBackendStatus, checkDbStatus, checkAhrStatus } from '../../lib/api';

export default function SystemStatus() {

    const [status, setStatus] = useState({ backend: "N/A", ahr: "N/A", db: "N/A" });

    useEffect(() => {
        let mounted = true;
        const load = async () => {
            // 1) Verifica backend
            const backend = await checkBackendStatus();
            if (!mounted) return;
            setStatus((prev) => ({ ...prev, backend }));

            // 2) Se backend ok, lancia DB e AHR in parallelo e aggiorna man mano
            if (backend === 'ok') {
                // Imposta in attesa (grigio) finché non arrivano i risultati
                setStatus((prev) => ({ ...prev, db: 'N/A', ahr: 'N/A' }));
                checkDbStatus().then((db) => { if (mounted) setStatus((prev) => ({ ...prev, db })); });
                checkAhrStatus().then((ahr) => { if (mounted) setStatus((prev) => ({ ...prev, ahr })); });
            } else {
                // Backend giù: DB/AHR non verificabili (rimangono grigi)
                setStatus((prev) => ({ ...prev, db: 'N/A', ahr: 'N/A' }));
            }
        };
        load();
        const id = setInterval(load, 30000);
        return () => { mounted = false; clearInterval(id); };
    }, []);

    const dotClass = (s: string) => s === 'ok' ? 'bg-green-500' : (s === 'ko' ? 'bg-red-500' : 'bg-gray-400');

    return (
        <div className="p-2">
            <div className="flex items-center gap-4 text-xs text-slate-500 ps-3">
                <div className="flex items-center gap-2">
                    <span className={`inline-block w-2.5 h-2.5 rounded-full ${dotClass(status.backend)}`}></span>
                    <span>Backend</span>
                </div>
                <div className="flex items-center gap-2">
                    <span className={`inline-block w-2.5 h-2.5 rounded-full ${dotClass(status.db)}`}></span>
                    <span>DB</span>
                </div>
                <div className="flex items-center gap-2">
                    <span className={`inline-block w-2.5 h-2.5 rounded-full ${dotClass(status.ahr)}`}></span>
                    <span>AHR</span>
                </div>
            </div>
        </div>
    );
}